import ExpertToolSportsGoal from 'dashboard/templates/views/ExpertTool/ExpertToolSportsGoal';

export default {
  path: 'sports-goal',
  name: 'PatientExpertToolSportsGoal',
  component: ExpertToolSportsGoal,
  meta: {
    // title: 'Patient - Expert Tool - Sports Goal',
    title: t => `${t('people.patient')} - ${t('expertTool.title')} - ${t('pa.sportsGoal')}`,
  },
};
